import {makeAutoObservable} from "mobx"
import {api, catchApi} from "../../api"
import {CustomerDetailDto} from "../../api/cms"
import {equals} from "../../utils"
import {validationStore} from "../ValidationStore"

const emptyObject = {
    name: '',
    active: true,
    customerNumber: '',
    displayName: '',
    address: {
        city: '',
        addition: '',
        country: '',
        street: '',
        houseNumber: '',
        postCode: ''
    }
}

class CmsCreateStore {
    get valid(): boolean {
        return this._valid
    }

    set valid(value: boolean) {
        this._valid = value
    }
    get creating(): boolean {
        return this._creating
    }

    set creating(value: boolean) {
        this._creating = value
    }
    get addressStreet(): string {
        return this._addressStreet
    }

    set addressStreet(value: string) {
        this._addressStreet = value
    }
    get addressPostCode(): string {
        return this._addressPostCode
    }

    set addressPostCode(value: string) {
        this._addressPostCode = value
    }
    get addressHouseNumber(): string {
        return this._addressHouseNumber
    }

    set addressHouseNumber(value: string) {
        this._addressHouseNumber = value
    }
    get addressCountry(): string {
        return this._addressCountry
    }

    set addressCountry(value: string) {
        this._addressCountry = value
    }
    get addressCity(): string {
        return this._addressCity
    }

    set addressCity(value: string) {
        this._addressCity = value
    }
    get addressAddition(): string {
        return this._addressAddition
    }

    set addressAddition(value: string) {
        this._addressAddition = value
    }
    get name(): string {
        return this._name
    }

    set name(value: string) {
        this._name = value
    }
    get displayName(): string {
        return this._displayName
    }

    set displayName(value: string) {
        this._displayName = value
    }
    get customerNumber(): string {
        return this._customerNumber
    }

    set customerNumber(value: string) {
        this._customerNumber = value
    }
    get active(): boolean {
        return this._active
    }

    set active(value: boolean) {
        this._active = value
    }
    get id(): string {
        return this._id
    }

    set id(value: string) {
        this._id = value
    }

    get dirty(): boolean {

        const current = this.build()
        return !equals(emptyObject, current)
    }

    private _id: string = ''
    private _creating: boolean = false
    private _valid: boolean = false


    private _active: boolean = true
    private _customerNumber: string = ''
    private _displayName: string = ''
    private _name: string = ''
    private _addressAddition: string = ''
    private _addressCity: string = ''
    private _addressCountry: string = 'DE'
    private _addressHouseNumber: string = ''
    private _addressPostCode: string = ''
    private _addressStreet: string = ''

    constructor() {
        makeAutoObservable(this)
    }

    async create(): Promise<string | void> {
        this.creating = true
        const dto = this.build()
        const result = await catchApi(async () => await api.cms.api.createCustomer(dto))
        this.creating = false
        return result?.data?.id
    }

    async validate() {
        this.valid = false
        const dto = this.build()
        await validationStore.validateWithQuery(api.cms.api.validateCustomer, dto, {validateCustomerNumber: true})

        this.valid = Boolean(validationStore.valid)
    }

    public reset() {
        this.valid = false
        this.active = true
        this.customerNumber =''
        this.displayName = ''
        this.name = ''
        this.addressCity = ''
        this.addressAddition = ''
        this.addressCountry = 'DE'
        this.addressHouseNumber = ''
        this.addressPostCode = ''
        this.addressStreet = ''
    }

    public build(): CustomerDetailDto {
        const {
            active,
            customerNumber,
            displayName,
            name,
            addressCity,
            addressStreet,
            addressAddition,
            addressCountry,
            addressHouseNumber,
            addressPostCode,
        } = this
        return {
            data: {
                name,
                active,
                customerNumber,
                displayName,
                address: {
                    city: addressCity,
                    addition: addressAddition,
                    country: addressCountry,
                    street: addressStreet,
                    houseNumber: addressHouseNumber,
                    postCode: addressPostCode
                }
            }
        }
    }
}

const cmsCreateStore = new CmsCreateStore()

export {
    cmsCreateStore
}
